<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

      <div v-if="loading" class="text-center pt-2 pb-2"><i class="fas fa-spinner fa-spin"></i></div>
      <p v-else-if="views.length == 0" class="pt-3 text-center">No views</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table">
          <tbody>
            <tr v-for="(view, index) in views" :key="index.id">
              
              <td class="pl-3">
                <a :href="'http://ip-api.com/json/'+view.ip" target="_blank" class="iplink">{{view.ip}}</a>
              </td>
              <td class="pl-3">
                <a v-if="view.product" :href="`/product/${view.product.id}/view`" target="_blank">{{view.product.name}}</a>
                <div v-else>Product not found</div>
                </td>
              <td class="agent"><span :title="view.agent"><i :class="view.agent_logo+' fa-2x logo'"></i></span></td>
              <td class="pl-3">{{view.city}}</td>
              <td class="pl-3"><img :src="'/images/flags/svg/'+view.country_flag" class="country_flag" :title="view.country"></td>
              <td class="pl-3 text-nowrap"><timeago
                  :datetime="view.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(view.created_at)"></timeago></td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">IP • Country • Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index">
  
        <td class="pl-2">
            <div>{{ view.ip }}</div>
            <div>{{ view.country }}</div>
            <div><timeago
                  :datetime="view.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(view.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>
export default {
  data() {
    return {
      views: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getViews();
  },

  methods: {
    getViews() {
      
      this.loading = true;

      axios.post('/analytics/get', {type: 'list'}).
      then((response) => {
        this.views = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
td.agent { text-align: left; width:70px; }
</style>